import { useTranslation } from 'react-i18next'

import { QrIcon } from '@pleio/icons/qr'

import IconButton from 'js/components/IconButton'

type Props = {
    guid: string
}

const ViewQrCode = ({ guid }: Props) => {
    const { t } = useTranslation()

    return (
        <div className="EventAction">
            <IconButton
                variant="primary"
                radiusStyle="rounded"
                className="EventActionButton"
                as="a"
                href={`/qr/access/${guid}`}
            >
                <QrIcon />
                {t('entity-event.qr-code')}
            </IconButton>
        </div>
    )
}

export default ViewQrCode
